export default __webpack_public_path__ + "static/media/405.05d1c8b3.png";